import { render, staticRenderFns } from "./job-report-layout.component.vue?vue&type=template&id=86f72602"
import script from "./job-report-layout.component.ts?vue&type=script&lang=ts&external"
export * from "./job-report-layout.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports